import { render, staticRenderFns } from "./ScanCopyFormBlock.vue?vue&type=template&id=00c8f1c9"
import script from "./ScanCopyFormBlock.vue?vue&type=script&lang=js"
export * from "./ScanCopyFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports